import type { UserRole } from '@/api/generated/model';
import { hasRole } from '@/auth/roles';
import { useCurrentUser } from '@/auth/useCurrentUser';

/** Показывать ли действие: те же правила, что проверяет API (кнопку без прав не рисуем). */
export function useHasRole(min: UserRole): boolean {
  const { user } = useCurrentUser();
  return user !== null && hasRole(user.role, min);
}
